import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';
import { htmlDecode } from '../helpers/functions';

// import { mapStyles } from './mapStyles';

import { ReactComponent as Logo } from '../assets/HRT_Logo.svg';

const mapOptions = {
  fullscreenControl: false,
  zoomControl: false,
  streetViewControl: false,
  mapTypeControl: false,
};

const MapWithInfoBox = withScriptjs(
  withGoogleMap((props) => {
    let lat = parseFloat(props.lat);
    let long = parseFloat(props.long);
    return (
      <GoogleMap
        defaultZoom={10}
        defaultCenter={{ lat: lat, lng: long }}
        options={mapOptions}
      >
        <Marker
          position={{ lat: lat, lng: long }}
          onClick={props.handleInfoOpen}
        />
        {props.infoOpen && props.address && (
          <InfoWindow position={{ lat: lat, lng: long }}>
            <div
              style={{
                background: `white`,
              }}
            >
              {props.address && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(props.address),
                  }}
                />
              )}
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    );
  })
);

export function GoogleMapDisplay({
  logo,
  apikey,
  lat,
  long,
  address,
  ...props
}) {
  let apiUrl = `https://maps.googleapis.com/maps/api/js?key=${apikey}&v=3.exp&libraries=geometry,drawing,places`;
  const [infoOpen, setInfoOpen] = React.useState(true);
  function handleInfoOpen() {
    setInfoOpen((val) => !val);
  }
  return (
    <div className="google-map-display">
      {lat && long && (
        <MapWithInfoBox
          googleMapURL={apiUrl}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          long={long}
          lat={lat}
          logo={logo}
          infoOpen={infoOpen}
          handleInfoOpen={handleInfoOpen}
          address={address}
          className="w-full"
        />
      )}
    </div>
  );
}
